export default __webpack_public_path__ + "static/media/Logo-Masdel.7f84a0aa.png";